import {
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
} from 'reactstrap';

import classnames from 'classnames';
import { useState } from 'react';
import AccountDetailsTab from './AccountDetailsTab';
import ContactsTab from './ContactsTab';
import AddressesTab from './AddressesTab';
import FinancialTab from './FinancialTab';
import NotesTab from './NotesTab';
import DocumentsTab from './DocumentsTab';
import HistoryTab from './HistoryTab';
import SettingsTab from './SettingsTab';

const AccountSubmenu = ({ setIsDetailsTab }: { setIsDetailsTab: (isDetailsTab: boolean) => void }) => {
  const [activeTab, setActiveTab] = useState('1');

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsDetailsTab(tab === '1');
    }
  };

  const tabs = [
    {
      id: '1',
      name: 'Details',
    },
    {
      id: '2',
      name: 'Contacts',
    },
    {
      id: '3',
      name: 'Addresses',
    },
    {
      id: '4',
      name: 'Financial',
    },
    {
      id: '5',
      name: 'Notes',
    },
    {
      id: '6',
      name: 'Documents',
    },
    {
      id: '7',
      name: 'History',
    },
    {
      id: '8',
      name: 'Settings',
    },
  ];

  return (
    <div>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardBody>
              <Nav pills className="nav nav-tabs-custom arrow-navtabs nav-success mb-3">
                {tabs.map((tab) => (
                  <NavItem key={tab.id}>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({ active: activeTab === tab.id })}
                      onClick={() => toggleTab(tab.id)}
                    >
                      {tab.name}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <TabContent activeTab={activeTab} className="text-muted">
                <TabPane tabId="1" id="arrow-details">
                  <AccountDetailsTab />
                </TabPane>
                <TabPane tabId="2" id="arrow-contacts">
                  <ContactsTab />
                </TabPane>
                <TabPane tabId="3" id="arrow-addresses">
                  <AddressesTab />
                </TabPane>
                <TabPane tabId="4" id="arrow-financial">
                  <FinancialTab />
                </TabPane>
                <TabPane tabId="5" id="arrow-notes">
                  <NotesTab />
                </TabPane>
                <TabPane tabId="6" id="arrow-documents">
                  <DocumentsTab />
                </TabPane>
                <TabPane tabId="7" id="arrow-history">
                  <HistoryTab />
                </TabPane>
                <TabPane tabId="8" id="arrow-settings">
                  <SettingsTab />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AccountSubmenu;
